<h2 *ngIf="applicant || organization"
  class="mb-2 font-875-rem font-550">
  <yc-i18n
    key="GLOBAL:hdrApplicantDetails"
    defaultValue="Applicant Details">
  </yc-i18n>
</h2>

<div class="d-flex">
  <!-- Org -->
  <div *ngIf="organization"
    class="flex-basis-50">
    <yc-nonprofit-block-table
      [name]="organization.name"
      [addressString]="organization.addressString"
      [registrationId]="organization.identification"
      [isPrivateOrg]="organization.isPrivateOrg"
      [icon]="{
        iconURL: organization.image
      } | getOrgIcon"> 
    </yc-nonprofit-block-table>
  </div>

  <!-- Applicant -->
  <div *ngIf="applicant"
    class="flex-basis-50">
    <gc-applicant-block
      [isMasked]="isMasked"
      [showMaskedToggle]="false"
      [name]="isMasked ?
        ('GLOBAL:textApplicantInfoIsMasked' | ycI18n: 'Applicant information is masked') :
        (applicant.firstName + ' ' + applicant.lastName)"
      [email]="isMasked ? '' : applicant.email"
      [phone]="isMasked ? '' : applicant.phoneNumber"
      [addressString]="applicant.addressString"
      [initials]="isMasked ?
        '' :
        applicant.firstName[0] + applicant.lastName[0]"
      [forTable]="true">
    </gc-applicant-block>
  </div>
</div>

